'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _helper = require('./helper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rotatable = function (_Component) {
  _inherits(Rotatable, _Component);

  function Rotatable(props) {
    _classCallCheck(this, Rotatable);

    var _this = _possibleConstructorReturn(this, (Rotatable.__proto__ || Object.getPrototypeOf(Rotatable)).call(this, props));

    _this.handleStartRotate = _this.handleStartRotate.bind(_this);
    _this.handleRotate = _this.handleRotate.bind(_this);
    _this.handleStopRotate = _this.handleStopRotate.bind(_this);

    _this.state = { rotating: false, angle: 0 };
    return _this;
  }

  _createClass(Rotatable, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addHandle();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (!this.state.rotating) {
        this.addHandle();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.handle) {
        this.handle.removeEventListener('mousedown', this.handleStartRotate);
      }
      document.removeEventListener('mouseup', this.handleStopRotate);
    }
  }, {
    key: 'addHandle',
    value: function addHandle() {
      this.rotatable.querySelectorAll('.rotate-handle-holder').forEach(function (e) {
        return e.remove();
      });
      if (!this.props.canRotate) {
        return;
      }

      this.handleContainer = document.createElement('div');
      this.handleContainer.classList.add('rotate-handle-holder');

      this.handle = document.createElement('div');
      this.handle.classList.add('rotate-handle');
      this.handleContainer.appendChild(this.handle);
      this.rotatable.appendChild(this.handleContainer);

      this.handle.addEventListener('mousedown', this.handleStartRotate);
      document.addEventListener('mouseup', this.handleStopRotate);
    }
  }, {
    key: 'handleStartRotate',
    value: function handleStartRotate(e) {
      var isRightButton = false;
      if ('which' in e) {
        isRightButton = e.which === 3;
      } else if ('button' in e) {
        isRightButton = e.button === 2;
      }

      if (isRightButton) {
        return;
      }

      var onRotateStart = this.props.onRotateStart;


      e.stopPropagation();
      document.addEventListener('mousemove', this.handleRotate);

      if (onRotateStart) {
        onRotateStart(e, this.rotatable, this.state.angle);
      }

      this.setState({ rotating: true });
    }
  }, {
    key: 'handleRotate',
    value: function handleRotate(e) {
      var _this2 = this;

      e.stopPropagation();
      e.preventDefault();
      e.cancelBubble = true;
      e.returnValue = false;
      if (!this.state.rotating) {
        return;
      }

      var onRotate = this.props.onRotate;

      var bounds = this.rotatable.getBoundingClientRect();
      var centerX = bounds.left + this.rotatable.clientWidth / 2;
      var centerY = bounds.top + this.rotatable.clientHeight / 2;
      var mouseX = e.pageX - (document.documentElement.scrollLeft || document.body.scrollLeft);
      var mouseY = e.pageY - (document.documentElement.scrollTop || document.body.scrollTop);
      var angleRad = Math.atan2(mouseX - centerX, -(mouseY - centerY));
      var angleDeg = angleRad * (180 / Math.PI);

      // For translate rule.
      var matrixArray = (0, _helper.getTransformMatrix)(this.rotatable);
      this.rotatable.style.transform = 'translate(' + matrixArray[4] + 'px, ' + matrixArray[5] + 'px) rotate(' + angleDeg + 'deg)';

      var angleNormalized = angleDeg > 0 ? angleDeg : 360 + angleDeg;

      this.setState({ angle: angleNormalized }, function () {
        if (onRotate) {
          onRotate(e, _this2.rotatable, angleNormalized);
        }
      });
    }
  }, {
    key: 'handleStopRotate',
    value: function handleStopRotate(e) {
      var _this3 = this;

      if (!this.state.rotating) {
        return;
      }

      var onRotateStop = this.props.onRotateStop;


      document.removeEventListener('mousemove', this.handleRotate);

      this.setState({ rotating: false }, function () {
        if (onRotateStop) {
          onRotateStop(e, _this3.rotatable, _this3.state.angle + 'deg');
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var children = _react2.default.Children.toArray(this.props.children);

      return _react2.default.cloneElement(children[0], {
        ref: function ref(el) {
          return _this4.rotatable = (0, _reactDom.findDOMNode)(el);
        }
      });
    }
  }]);

  return Rotatable;
}(_react.Component);

Rotatable.propTypes = {
  children: _propTypes2.default.element.isRequired,
  onRotateStart: _propTypes2.default.func,
  onRotate: _propTypes2.default.func,
  onRotateStop: _propTypes2.default.func,
  canRotate: _propTypes2.default.bool
};

Rotatable.defaultProps = {
  canRotate: true
};

exports.default = Rotatable;